/**
 * Common methods/constants
 */

//axios.defaults.baseURL = 'http://13.127.93.174:8080/Aufuq-service/';

export const Util = {
    baseURL : "",
    loginStatus : false,
    userId : '',
    user : "",
    baseURlForDownload: window.location.hostname === "localhost" 
        ? 'https://d2c4d2pjttf9c7.cloudfront.net/' 
        : window.location.hostname === "elmaam.com" 
            ? 'https://elmaam.com/' 
            : 'https://d2c4d2pjttf9c7.cloudfront.net/',  
    // getBaseUrlForDownload: function() {
    //     // Determine base URL for download based on hostname
    //     if(window.location.hostname === "localhost"){
    //         return 'https://d2c4d2pjttf9c7.cloudfront.net/';
    //     }else if(window.location.hostname === "elmaam.com"){
    //         return 'https://elmaam.com/';
    //     }else{
    //         return 'https://d2c4d2pjttf9c7.cloudfront.net/';
    //     }
    // },
    //getBaseUrlForDownload : "https://d2c4d2pjttf9c7.cloudfront.net/",
    saveToSession : function(key,value){
        sessionStorage.setItem(key, JSON.stringify(value));
    },
    getFromSession : function(key){
        const data=sessionStorage.getItem(key);
        if(data == "undefined" || data == null) return null;
        return JSON.parse(data);
    },
    clearSession : function(key){
        sessionStorage.removeItem(key);
    },
    checkValidSession : function(){
        const data=sessionStorage.getItem("userData");
        if (data === null) return false;
        return true;

    },
    ibtikarEnabled :['AA_ORG']
}
